import script from "./PdfPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./PdfPreview.vue?vue&type=script&lang=ts&setup=true"

import "./PdfPreview.vue?vue&type=style&index=0&id=3528c2a2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3528c2a2"]])

export default __exports__